import { useTranslation } from "react-i18next";
import MillimetreSquared from "../../../../../../components/Math/Units/Metric/MillimetreSquared";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

//Querschnitt Verpresskörper
function QuerschnittVerpresskoerper({ querschnittVerpresskoerper }) {
  const { t } = useTranslation("translation");
  const A_c_Formula = `\\displaystyle A_{c} = \\frac{\\pi}{4}\\cdot\\left( D_{c^2}-D_{a,cal^2}\\right)`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterGroutingBody.cementCrossSection")}</p>}
      indicesValue={
        <span>
          A<sub>c</sub>
        </span>
      }
      formulaValue={<ToolTip id={"A_c_Formula"} type={IconType.FORMULA} formula={A_c_Formula} />}
      inputValue={
        <span className="input">
          <NumberFormatText value={querschnittVerpresskoerper} decimalScale={0} />
        </span>
      }
      unitValue={<MillimetreSquared />}
    />
  );
}

export default QuerschnittVerpresskoerper;
